const doc = [({"da":({"js":({"users":({"edit":({"form":({"two_factor_authentication":({"two_factor_authentication":"To-faktor godkendelse"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;